module.exports = __webpack_public_path__ + "img/image-02.1435fc52.jpeg";